/*
  Shopify tarnib mõne filtri väärtuse ainult inglise keeles (Saadavus ja loogilised
  metafieldid). Neid ei saa teema locale-failist ega Search & Discovery seadetest
  muuta, sest need tulevad Shopify filtri-API-st. Siin asendame ainult näidatava
  sildi — filtri väärtus ja URL jäävad puutumata.
*/
(function () {
  var MAP = {
    'In stock': 'Laos',
    'Out of stock': 'Otsas',
    'Yes': 'Jah',
    'No': 'Ei'
  };

  function translateNode(node) {
    if (node.nodeType !== 3) return;
    var t = node.nodeValue.trim();
    if (MAP[t]) node.nodeValue = node.nodeValue.replace(t, MAP[t]);
  }

  function run(root) {
    var scopes = (root || document).querySelectorAll(
      '.facets label, .facets .facets__label, .filter-remove-buttons button, .facets__summary'
    );
    scopes.forEach(function (el) {
      el.childNodes.forEach(translateNode);
      el.querySelectorAll('span, small').forEach(function (s) {
        s.childNodes.forEach(translateNode);
      });
    });
  }

  function boot() {
    run(document);
    var mo = new MutationObserver(function (records) {
      for (var i = 0; i < records.length; i++) {
        var added = records[i].addedNodes;
        for (var j = 0; j < added.length; j++) {
          if (added[j].nodeType === 1) run(added[j].closest ? added[j] : document);
        }
      }
    });
    mo.observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot, { once: true });
  } else {
    boot();
  }
})();
